import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableProps as Co, dataTableInjectionKey as So } from "./interface.js";
import po from "./MainTable.js";
import Po from "./styles/index.cssr.js";
import { useCheck as xo } from "./use-check.js";
import { useExpand as wo } from "./use-expand.js";
import { useGroupHeader as yo } from "./use-group-header.js";
import { useResizable as zo } from "./use-resizable.js";
import { useScroll as To } from "./use-scroll.js";
import { useTableData as Ho } from "./use-table-data.js";
import { generateCsv as ko } from "./utils.js";
import Bo from "../../_mixins/use-config.js";
import { useRtl as Fo } from "../../_mixins/use-rtl.js";
import Mo from "../../_mixins/use-theme.js";
import Do from "../../_mixins/use-locale.js";
import { createId as Eo } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { createKey as p } from "../../_utils/cssr/index.js";
import { useThemeClass as Ko } from "../../_mixins/use-css-vars-class.js";
import { resolveSlot as Lo } from "../../_utils/vue/resolve-slot.js";
import Oo from "../../pagination/src/Pagination.js";
import { warnOnce as c } from "../../_utils/naive/warn.js";
import Io from "../styles/light.js";
import $o from "../../_internal/loading/src/Loading.js";
import { download as Uo } from "../../_utils/dom/download.js";
import { defineComponent as Ao, watchEffect as No, computed as n, provide as jo, h as i } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as P, toRef as o } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as Wo } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const bt = Ao({
  name: "DataTable",
  alias: ["AdvancedTable"],
  props: Co,
  slots: Object,
  setup(e, {
    slots: h
  }) {
    process.env.NODE_ENV !== "production" && No(() => {
      e.onPageChange !== void 0 && c("data-table", "`on-page-change` is deprecated, please use `on-update:page` instead."), e.onPageSizeChange !== void 0 && c("data-table", "`on-page-size-change` is deprecated, please use `on-update:page-size` instead."), e.onSorterChange !== void 0 && c("data-table", "`on-sorter-change` is deprecated, please use `on-update:sorter` instead."), e.onFiltersChange !== void 0 && c("data-table", "`on-filters-change` is deprecated, please use `on-update:filters` instead."), e.onCheckedRowKeysChange !== void 0 && c("data-table", "`on-checked-row-keys-change` is deprecated, please use `on-update:checked-row-keys` instead.");
    });
    const {
      mergedBorderedRef: l,
      mergedClsPrefixRef: d,
      inlineThemeDisabled: f,
      mergedRtlRef: B
    } = Bo(e), F = Fo("DataTable", B, d), M = n(() => {
      const {
        bottomBordered: t
      } = e;
      return l.value ? !1 : t !== void 0 ? t : !0;
    }), m = Mo("DataTable", "-data-table", Po, Io, e, d), x = P(null), u = P(null), {
      getResizableWidth: w,
      clearResizableWidth: D,
      doUpdateResizableWidth: E
    } = zo(), {
      rowsRef: K,
      colsRef: L,
      dataRelatedColsRef: O,
      hasEllipsisRef: I
    } = yo(e, w), {
      treeMateRef: R,
      mergedCurrentPageRef: y,
      paginatedDataRef: v,
      rawPaginatedDataRef: z,
      selectionColumnRef: T,
      hoverKeyRef: $,
      mergedPaginationRef: H,
      mergedFilterStateRef: U,
      mergedSortStateRef: A,
      childTriggerColIndexRef: N,
      doUpdatePage: j,
      doUpdateFilters: W,
      onUnstableColumnResize: V,
      deriveNextSorter: X,
      filter: _,
      filters: G,
      clearFilter: q,
      clearFilters: J,
      clearSorter: Q,
      page: Y,
      sort: Z
    } = Ho(e, {
      dataRelatedColsRef: O
    }), ee = (t) => {
      const {
        fileName: r = "data.csv",
        keepOriginalData: a = !1
      } = t || {}, b = a ? e.data : z.value, C = ko(e.columns, b, e.getCsvCell, e.getCsvHeader), S = new Blob([C], {
        type: "text/csv;charset=utf-8"
      }), g = URL.createObjectURL(S);
      Uo(g, r.endsWith(".csv") ? r : `${r}.csv`), URL.revokeObjectURL(g);
    }, {
      doCheckAll: oe,
      doUncheckAll: te,
      doCheck: re,
      doUncheck: ae,
      headerCheckboxDisabledRef: ne,
      someRowsCheckedRef: ie,
      allRowsCheckedRef: le,
      mergedCheckedRowKeySetRef: de,
      mergedInderminateRowKeySetRef: se
    } = xo(e, {
      selectionColumnRef: T,
      treeMateRef: R,
      paginatedDataRef: v
    }), {
      stickyExpandedRowsRef: ce,
      mergedExpandedRowKeysRef: fe,
      renderExpandRef: me,
      expandableRef: ge,
      doUpdateExpandedRowKeys: he
    } = wo(e, R), {
      handleTableBodyScroll: ue,
      handleTableHeaderScroll: Re,
      syncScrollState: ve,
      setHeaderScrollLeft: be,
      leftActiveFixedColKeyRef: Ce,
      leftActiveFixedChildrenColKeysRef: Se,
      rightActiveFixedColKeyRef: pe,
      rightActiveFixedChildrenColKeysRef: Pe,
      leftFixedColumnsRef: xe,
      rightFixedColumnsRef: we,
      fixedColumnLeftMapRef: ye,
      fixedColumnRightMapRef: ze
    } = To(e, {
      bodyWidthRef: x,
      mainTableInstRef: u,
      mergedCurrentPageRef: y
    }), {
      localeRef: Te
    } = Do("DataTable"), He = n(() => e.virtualScroll || e.flexHeight || e.maxHeight !== void 0 || I.value ? "fixed" : e.tableLayout);
    jo(So, {
      props: e,
      treeMateRef: R,
      renderExpandIconRef: o(e, "renderExpandIcon"),
      loadingKeySetRef: P(/* @__PURE__ */ new Set()),
      slots: h,
      indentRef: o(e, "indent"),
      childTriggerColIndexRef: N,
      bodyWidthRef: x,
      componentId: Eo(),
      hoverKeyRef: $,
      mergedClsPrefixRef: d,
      mergedThemeRef: m,
      scrollXRef: n(() => e.scrollX),
      rowsRef: K,
      colsRef: L,
      paginatedDataRef: v,
      leftActiveFixedColKeyRef: Ce,
      leftActiveFixedChildrenColKeysRef: Se,
      rightActiveFixedColKeyRef: pe,
      rightActiveFixedChildrenColKeysRef: Pe,
      leftFixedColumnsRef: xe,
      rightFixedColumnsRef: we,
      fixedColumnLeftMapRef: ye,
      fixedColumnRightMapRef: ze,
      mergedCurrentPageRef: y,
      someRowsCheckedRef: ie,
      allRowsCheckedRef: le,
      mergedSortStateRef: A,
      mergedFilterStateRef: U,
      loadingRef: o(e, "loading"),
      rowClassNameRef: o(e, "rowClassName"),
      mergedCheckedRowKeySetRef: de,
      mergedExpandedRowKeysRef: fe,
      mergedInderminateRowKeySetRef: se,
      localeRef: Te,
      expandableRef: ge,
      stickyExpandedRowsRef: ce,
      rowKeyRef: o(e, "rowKey"),
      renderExpandRef: me,
      summaryRef: o(e, "summary"),
      virtualScrollRef: o(e, "virtualScroll"),
      virtualScrollXRef: o(e, "virtualScrollX"),
      heightForRowRef: o(e, "heightForRow"),
      minRowHeightRef: o(e, "minRowHeight"),
      virtualScrollHeaderRef: o(e, "virtualScrollHeader"),
      headerHeightRef: o(e, "headerHeight"),
      rowPropsRef: o(e, "rowProps"),
      stripedRef: o(e, "striped"),
      checkOptionsRef: n(() => {
        const {
          value: t
        } = T;
        return t == null ? void 0 : t.options;
      }),
      rawPaginatedDataRef: z,
      filterMenuCssVarsRef: n(() => {
        const {
          self: {
            actionDividerColor: t,
            actionPadding: r,
            actionButtonMargin: a
          }
        } = m.value;
        return {
          "--n-action-padding": r,
          "--n-action-button-margin": a,
          "--n-action-divider-color": t
        };
      }),
      onLoadRef: o(e, "onLoad"),
      mergedTableLayoutRef: He,
      maxHeightRef: o(e, "maxHeight"),
      minHeightRef: o(e, "minHeight"),
      flexHeightRef: o(e, "flexHeight"),
      headerCheckboxDisabledRef: ne,
      paginationBehaviorOnFilterRef: o(e, "paginationBehaviorOnFilter"),
      summaryPlacementRef: o(e, "summaryPlacement"),
      filterIconPopoverPropsRef: o(e, "filterIconPopoverProps"),
      scrollbarPropsRef: o(e, "scrollbarProps"),
      syncScrollState: ve,
      doUpdatePage: j,
      doUpdateFilters: W,
      getResizableWidth: w,
      onUnstableColumnResize: V,
      clearResizableWidth: D,
      doUpdateResizableWidth: E,
      deriveNextSorter: X,
      doCheck: re,
      doUncheck: ae,
      doCheckAll: oe,
      doUncheckAll: te,
      doUpdateExpandedRowKeys: he,
      handleTableHeaderScroll: Re,
      handleTableBodyScroll: ue,
      setHeaderScrollLeft: be,
      renderCell: o(e, "renderCell")
    });
    const ke = {
      filter: _,
      filters: G,
      clearFilters: J,
      clearSorter: Q,
      page: Y,
      sort: Z,
      clearFilter: q,
      downloadCsv: ee,
      scrollTo: (t, r) => {
        var a;
        (a = u.value) === null || a === void 0 || a.scrollTo(t, r);
      }
    }, k = n(() => {
      const {
        size: t
      } = e, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          borderColor: a,
          tdColorHover: b,
          tdColorSorting: C,
          tdColorSortingModal: S,
          tdColorSortingPopover: g,
          thColorSorting: Fe,
          thColorSortingModal: Me,
          thColorSortingPopover: De,
          thColor: Ee,
          thColorHover: Ke,
          tdColor: Le,
          tdTextColor: Oe,
          thTextColor: Ie,
          thFontWeight: $e,
          thButtonColorHover: Ue,
          thIconColor: Ae,
          thIconColorActive: Ne,
          filterSize: je,
          borderRadius: We,
          lineHeight: Ve,
          tdColorModal: Xe,
          thColorModal: _e,
          borderColorModal: Ge,
          thColorHoverModal: qe,
          tdColorHoverModal: Je,
          borderColorPopover: Qe,
          thColorPopover: Ye,
          tdColorPopover: Ze,
          tdColorHoverPopover: eo,
          thColorHoverPopover: oo,
          paginationMargin: to,
          emptyPadding: ro,
          boxShadowAfter: ao,
          boxShadowBefore: no,
          sorterSize: io,
          resizableContainerSize: lo,
          resizableSize: so,
          loadingColor: co,
          loadingSize: fo,
          opacityLoading: mo,
          tdColorStriped: go,
          tdColorStripedModal: ho,
          tdColorStripedPopover: uo,
          [p("fontSize", t)]: Ro,
          [p("thPadding", t)]: vo,
          [p("tdPadding", t)]: bo
        }
      } = m.value;
      return {
        "--n-font-size": Ro,
        "--n-th-padding": vo,
        "--n-td-padding": bo,
        "--n-bezier": r,
        "--n-border-radius": We,
        "--n-line-height": Ve,
        "--n-border-color": a,
        "--n-border-color-modal": Ge,
        "--n-border-color-popover": Qe,
        "--n-th-color": Ee,
        "--n-th-color-hover": Ke,
        "--n-th-color-modal": _e,
        "--n-th-color-hover-modal": qe,
        "--n-th-color-popover": Ye,
        "--n-th-color-hover-popover": oo,
        "--n-td-color": Le,
        "--n-td-color-hover": b,
        "--n-td-color-modal": Xe,
        "--n-td-color-hover-modal": Je,
        "--n-td-color-popover": Ze,
        "--n-td-color-hover-popover": eo,
        "--n-th-text-color": Ie,
        "--n-td-text-color": Oe,
        "--n-th-font-weight": $e,
        "--n-th-button-color-hover": Ue,
        "--n-th-icon-color": Ae,
        "--n-th-icon-color-active": Ne,
        "--n-filter-size": je,
        "--n-pagination-margin": to,
        "--n-empty-padding": ro,
        "--n-box-shadow-before": no,
        "--n-box-shadow-after": ao,
        "--n-sorter-size": io,
        "--n-resizable-container-size": lo,
        "--n-resizable-size": so,
        "--n-loading-size": fo,
        "--n-loading-color": co,
        "--n-opacity-loading": mo,
        "--n-td-color-striped": go,
        "--n-td-color-striped-modal": ho,
        "--n-td-color-striped-popover": uo,
        "--n-td-color-sorting": C,
        "--n-td-color-sorting-modal": S,
        "--n-td-color-sorting-popover": g,
        "--n-th-color-sorting": Fe,
        "--n-th-color-sorting-modal": Me,
        "--n-th-color-sorting-popover": De
      };
    }), s = f ? Ko("data-table", n(() => e.size[0]), k, e) : void 0, Be = n(() => {
      if (!e.pagination)
        return !1;
      if (e.paginateSinglePage)
        return !0;
      const t = H.value, {
        pageCount: r
      } = t;
      return r !== void 0 ? r > 1 : t.itemCount && t.pageSize && t.itemCount > t.pageSize;
    });
    return Object.assign({
      mainTableInstRef: u,
      mergedClsPrefix: d,
      rtlEnabled: F,
      mergedTheme: m,
      paginatedData: v,
      mergedBordered: l,
      mergedBottomBordered: M,
      mergedPagination: H,
      mergedShowPagination: Be,
      cssVars: f ? void 0 : k,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    }, ke);
  },
  render() {
    const {
      mergedClsPrefix: e,
      themeClass: h,
      onRender: l,
      $slots: d,
      spinProps: f
    } = this;
    return l == null || l(), i("div", {
      class: [`${e}-data-table`, this.rtlEnabled && `${e}-data-table--rtl`, h, {
        [`${e}-data-table--bordered`]: this.mergedBordered,
        [`${e}-data-table--bottom-bordered`]: this.mergedBottomBordered,
        [`${e}-data-table--single-line`]: this.singleLine,
        [`${e}-data-table--single-column`]: this.singleColumn,
        [`${e}-data-table--loading`]: this.loading,
        [`${e}-data-table--flex-height`]: this.flexHeight
      }],
      style: this.cssVars
    }, i("div", {
      class: `${e}-data-table-wrapper`
    }, i(po, {
      ref: "mainTableInstRef"
    })), this.mergedShowPagination ? i("div", {
      class: `${e}-data-table__pagination`
    }, i(Oo, Object.assign({
      theme: this.mergedTheme.peers.Pagination,
      themeOverrides: this.mergedTheme.peerOverrides.Pagination,
      disabled: this.loading
    }, this.mergedPagination))) : null, i(Wo, {
      name: "fade-in-scale-up-transition"
    }, {
      default: () => this.loading ? i("div", {
        class: `${e}-data-table-loading-wrapper`
      }, Lo(d.loading, () => [i($o, Object.assign({
        clsPrefix: e,
        strokeWidth: 20
      }, f))])) : null
    }));
  }
});
export {
  bt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/DataTable.js
// module id = 129
// module chunks = 67